export default "__VITE_ASSET__u_CjqrPr__"